import { ThemeIcon } from '@zorro/design-system/v2/ThemeIcon';
import { Group, Text } from '@zorro/web/design-system';
import { ElementType } from 'react';

type Props = {
  icon: ElementType;
  count: number;
};

export const EmployeeActivityLogPlanTypeBadge = ({
  icon: IconComponent,
  count,
  ...rest
}: Props) => (
  <Group gap={4} wrap="nowrap" display="inline-flex" {...rest}>
    <ThemeIcon size="24" color="default" {...(count > 1 && { width: '36' })}>
      <Group wrap="nowrap" gap="xs">
        <IconComponent stroke={1.5} />
        {count > 1 && (
          <Text
            size="xs"
            c="var(--color-icon-stroke-tag-gray)"
            fw={500}
            ml="-0.25rem"
          >
            {count}
          </Text>
        )}
      </Group>
    </ThemeIcon>
  </Group>
);
